module.exports = __webpack_public_path__ + "static/crowd-3c53ae0274e44851272cf39cd2c208f7.mp3";